export default __webpack_public_path__ + "8e28a740751ef31baba898d46c3793f4.png";